const BASE = "https://thainotarylaw.com";
const SHIPPED = ["th", "en", "zh", "ja", "ko", "vi", "id"] as const;
const MAP: Record<(typeof SHIPPED)[number], string> = {
  th: "th-TH", en: "en", zh: "zh-CN", ja: "ja-JP", ko: "ko-KR", vi: "vi-VN", id: "id-ID",
};

export function pdpaPillarHreflang() {
  return [
    ...SHIPPED.map((l) => ({
      rel: "alternate" as const,
      hrefLang: MAP[l],
      href: l === "th" ? `${BASE}/pdpa` : `${BASE}/${l}/pdpa`,
    })),
    { rel: "alternate" as const, hrefLang: "x-default", href: `${BASE}/pdpa` },
  ];
}

export function pdpaLeafHreflangTHOnly(path: string) {
  const abs = `${BASE}${path}`;
  return [
    { rel: "alternate" as const, hrefLang: "th-TH", href: abs },
    { rel: "alternate" as const, hrefLang: "x-default", href: abs },
  ];
}
